import React from 'react';
import {AutoField} from 'components/forms/fields';
import Section from 'components/forms/Section';
import {Typography, Grid} from '@material-ui/core';
import fields from '../cg719s/fields';
import {bootstrapOldForm} from 'components/forms/AutoSection';
import {useGetProfile} from 'hooks';
import {useContext} from 'react';
import {UserContext} from 'context/UserContext';

const Name = props => {
    const {schema} = bootstrapOldForm('Name', fields);
    const {data: profileData} = useGetProfile();

    const {user, profile} = useContext(UserContext);

    const askSSN = profileData?.applicant_previous_mmc === false;

    const initialValues = {
        applicant_name_first: user?.firstname || '',
        applicant_name_last: user?.lastname || '',
        applicant_name_middle: profile?.applicant_name_middle || '',
        applicant_MMC: user?.mmld_number || '',
        applicant_last_4: '',
    };

    // TO DO: how to display SSN last 4? Append X's, eg XXX-XX-1234  ? FE/BE?

    return (
        <Section {...props} schema={schema} initialValues={initialValues}>
            <Grid item xs={12}>
                <Typography variant='h6' align='left'>
                    Applicant Information
                </Typography>
            </Grid>
            <Grid item xs={12}></Grid>
            <AutoField
                field={fields['applicant_name_last']}
                name='applicant_name_last'
                key='applicant_name_last'
            />
            <AutoField
                field={fields['applicant_name_first']}
                name='applicant_name_first'
                key='applicant_name_first'
            />
            <AutoField
                field={fields['applicant_name_middle']}
                name='applicant_name_middle'
                key='applicant_name_middle'
            />
            {(askSSN === true || askSSN === 'true') && (
                <AutoField
                    field={fields['applicant_last_4']}
                    name='applicant_last_4'
                    key='applicant_last_4'
                />
            )}
            {(askSSN === false || askSSN === 'false') && (
                <AutoField
                    field={fields['applicant_MMC']}
                    name='applicant_MMC'
                    key='applicant_MMC'
                />
            )}

            {props.children}
        </Section>
    );
};

export default Name;
